export default __webpack_public_path__ + "static/media/menu.6b5e97cc.svg";